import request from './request'

// 获取所有省份
export function getAllProvinces() {
  return request({
    url: '/Province/GetAllProvinces',
    method: 'get',
    headers: {
      'accept': 'text/plain'
    }
  })
}

// 根据省份编码获取城市列表
export function getCitiesByProvince(provinceCode) {
  return request({
    url: `/City/GetCitiesByProvinceCode?provinceCode=${provinceCode}`,
    method: 'get',
    headers: {
      'accept': 'text/plain'
    }
  })
}

// 根据城市编码获取区县列表
export function getDistrictsByCity(cityCode) {
  return request({
    url: `/Area/GetAreasByCityCode?cityCode=${cityCode}`,
    method: 'get',
    headers: {
      'accept': 'text/plain'
    }
  })
}

// 获取学校列表
export const getSchools = (areaCode) => {
  return request({
    url: `/School/GetSchools?areaCode=${areaCode}`,
    method: 'post'
  })
}
